<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="none">
    <path
      d="M21.904 4.173 20.07.506A.917.917 0 0 0 19.25 0H2.75a.917.917 0 0 0-.82.506L.096 4.173a.926.926 0 0 0-.096.41v15.584A1.833 1.833 0 0 0 1.833 22h18.334A1.833 1.833 0 0 0 22 20.167V4.583a.927.927 0 0 0-.096-.41zM15.315 14.4l-3.666 3.666a.916.916 0 0 1-1.297 0l-3.667-3.667a.917.917 0 1 1 1.297-1.296l2.101 2.102V8.25a.917.917 0 0 1 1.834 0v6.954l2.101-2.103a.917.917 0 1 1 1.297 1.297zM2.4 3.667l.917-1.834h15.368l.917 1.834H2.399z" />
  </svg>
</template>
<script setup lang="ts">
defineOptions({
  name: 'mark-product-download'
})
</script>
